import makeSlice from '@web/slices/modal/sliceMaker'

const slice = makeSlice()

export default slice.reducer
